import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminDashboardPage: React.FC = () => {
  const { user, logout } = useAuth();

  // Not logged in
  if (!user) return <Navigate to="/admin/login" replace />;
  // Logged in but not admin
  if (user.role !== 'admin') return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-[#F4F6F9]">
      {/* Admin Nav */}
      <nav className="bg-[#1A1A2E] text-white h-[60px] flex items-center justify-between px-6">
        <div className="flex items-center space-x-3">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <span className="font-bold text-lg">Sasta Fashions — Admin</span>
        </div>
        <div className="flex items-center space-x-4">
          <span className="text-sm text-white/70">{user.email}</span>
          <button
            onClick={() => { logout(); }}
            className="text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg"
          >
            Logout
          </button>
        </div>
      </nav>

      {/* Dashboard Content */}
      <div className="p-8 max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Dashboard</h1>
        <p className="text-gray-500 mb-8">Welcome back, {user.name}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <p className="text-sm text-gray-500 mb-1">Total Orders</p>
            <p className="text-3xl font-bold text-[#1A1A2E]">—</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <p className="text-sm text-gray-500 mb-1">Total Users</p>
            <p className="text-3xl font-bold text-[#1A1A2E]">—</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <p className="text-sm text-gray-500 mb-1">Total Products</p>
            <p className="text-3xl font-bold text-[#1A1A2E]">—</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPage;
